// src/pages/StudentListPage.jsx
import React from "react";
import StudentListLayer from "../components/school/StudentListLayer";
import MasterLayout from "../masterLayout/MasterLayout";

export const StudentListPage = () => {
  return (
    <MasterLayout>
      <StudentListLayer />
    </MasterLayout>
  );
};

export default StudentListPage;
